import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Phone } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

const API = process.env.REACT_APP_BACKEND_URL;

export function LandingCallbackDialog() {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/leads/callback-request`, { name, phone });
      toast.success("Заявка принята! Мы перезвоним вам в ближайшее время.");
      setName("");
      setPhone("");
      setOpen(false);
    } catch (err) {
      toast.error("Не удалось отправить заявку. Попробуйте ещё раз.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="hover:text-slate-900 flex items-center gap-1.5"
        data-testid="landing-footer-callback-trigger"
      >
        <Phone className="w-3.5 h-3.5" />
        Обратный звонок
      </button>
      <DialogContent className="sm:max-w-sm" data-testid="callback-dialog">
        <DialogHeader>
          <DialogTitle>Закажите обратный звонок</DialogTitle>
          <DialogDescription>
            Оставьте имя и номер телефона — наш менеджер перезвонит вам в ближайшее рабочее время.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="callback-name">Имя</Label>
            <Input
              id="callback-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Как к вам обращаться"
              required
              data-testid="callback-name-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="callback-phone">Телефон</Label>
            <Input
              id="callback-phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+7 (___) ___-__-__"
              required
              data-testid="callback-phone-input"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#4E9BEE] hover:bg-[#3d87d6]"
            data-testid="callback-submit-button"
          >
            {loading ? "Отправляем…" : "Заказать звонок"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
